<template>
    <div class="menu-link" ref="root">
        <div class="label" @click="toggle">
            <slot name="label"></slot>
            <span class="chevron" :class="{opened}">
                <i class="icon angle-up" />
            </span>
        </div>
        <div class="submenu" v-if="opened" :style="submenuStyle" @click="closeAfterMenuItemClick" ref="submenu">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Ref} from 'vue-facing-decorator';

    @Component
    export default class OpenableMenu extends Vue {
        private opened: boolean = false;
        private submenuStyle: Record<string, string> = {};

        @Ref() public readonly root!: HTMLElement;
        @Ref() public readonly submenu!: HTMLElement;

        public mounted(): void {
            document.body.addEventListener('click', this.closeAfterOutsideClick);
        }

        public beforeUnmount(): void {
            document.body.removeEventListener('click', this.closeAfterOutsideClick);
        }

        public closeAfterMenuItemClick(): void {
            this.opened = false;
        }

        private closeAfterOutsideClick(e: MouseEvent): void {
            if (!this.root || !this.root.contains(e.target as HTMLElement)) {
                this.opened = false;
            }
        }

        public toggle(): void {
            this.opened = !this.opened;

            if (this.opened) {
                this.$nextTick((): void => {
                    const rect: DOMRect | undefined = this.submenu?.getBoundingClientRect();
                    if (rect && rect.right > window.innerWidth) {
                        this.submenuStyle.right = '0';
                        this.$forceUpdate();
                    }
                });
            } else {
                delete this.submenuStyle.right;
            }
        }
    }
</script>

<style lang="scss" scoped>
    div.menu-link {
        display: inline-block;
        text-align: left;

        .submenu {
            animation: var(--theme-generic-slidedown-animation);
            margin-top: .5rem;
            position: absolute;
            z-index: 10000;
            background: #fff;
            box-shadow: var(--generic-shadow-subtle);
        }

        + div.menu-link {
            margin-left: 1rem;
        }

        .chevron {
            .icon {
                vertical-align: -2px;
                background: var(--control-chevron-color);
                transition: transform ease-out 0.3s;
            }

            &.opened .icon {
                transform: rotate(180deg);
            }
        }

        .label {
            cursor: pointer;
        }
    }
</style>
